import { render, staticRenderFns } from "./exchangeDialog.vue?vue&type=template&id=3dc79f1c&scoped=true&"
import script from "./exchangeDialog.vue?vue&type=script&lang=js&"
export * from "./exchangeDialog.vue?vue&type=script&lang=js&"
import style0 from "./exchangeDialog.vue?vue&type=style&index=0&id=3dc79f1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc79f1c",
  null
  
)

export default component.exports